import * as React from 'react';
import { SubscriptionPlanDetailsDto } from 'src/com/sixdee/crbtportal/core/dto/subscriptionplandetails/subscriptionplandetailsdto';
import { Strings } from 'src/com/sixdee/crbtportal/utils/resources/strings';
import { ButtonComponent } from '../../../../toolkit/button/buttoncomponent';
import { UIComponentViewImpl } from '../../../../toolkit/uicomponentview';
import { ConfirmRequestConfirmButtonCSSStyleImpl } from '../../confirmrequest/confirmrequestconfirmbuttoncss';

import { SubscriptionFlashMessageComponentHandler, SubscriptionFlashMessageComponentProps, SubscriptionFlashMessageComponentState } from './flashsubscriptioncomponent';

import { LoaderWrapperComponent } from '../../loaderwrappercomponent';
import { LoaderComponent } from '../../../../toolkit/loader/loadercomponent';
import "./flashsubscription-style.css";
import { SubscriptionFlashMessageComponentCancelButtonCSSStyleImpl } from './flashsubscriptioncancelbuttoncss';
import { SubscriptionFlashMessageComponentCSSStyle } from './flashsubscriptioncss';
import { LanguageConst } from 'src/com/sixdee/crbtportal/utils/resources/languageconst';

export class SubscriptionFlashMessageComponentViewImpl extends UIComponentViewImpl<SubscriptionPlanDetailsDto> {
    private loaderWrapperComponent: LoaderWrapperComponent;
    bindHandlers() {
        this.onMonthlyHovered = this.onMonthlyHovered.bind(this);
        this.onWeeklyHovered = this.onWeeklyHovered.bind(this);
        this.onDailyHovered = this.onDailyHovered.bind(this);
        this.onMonthlyHoveredExit = this.onMonthlyHoveredExit.bind(this);
        this.onWeeklyHoveredExit = this.onWeeklyHoveredExit.bind(this);
        this.onDailyHoveredExit = this.onDailyHoveredExit.bind(this);
        this.onConfirmClick = this.onConfirmClick.bind(this);
        this.onCancelClick = this.onCancelClick.bind(this);
        this.onMonthlyPackSelected = this.onMonthlyPackSelected.bind(this);
        this.onDailyPackSelected = this.onDailyPackSelected.bind(this);
        this.onWeeklyPackSelected = this.onWeeklyPackSelected.bind(this);
    }

    draw(props: SubscriptionFlashMessageComponentProps, state: SubscriptionFlashMessageComponentState, cssStyle: SubscriptionFlashMessageComponentCSSStyle): JSX.Element | boolean {
        super.draw(props, state, cssStyle);

        return (
            <>
                <div id="subscription-flash-message-web-wrapper">
                    {
                        this.getWebView(props, state, cssStyle)
                    }
                </div>
                <div id="subscription-flash-message-mobile-wrapper">
                    {
                        this.getMobileView(props, state, cssStyle)
                    }
                </div>
                <LoaderWrapperComponent ref={(item: any) => this.loaderWrapperComponent = item} context={props.context} />
            </>

        );
    }

    getWebView(props: SubscriptionFlashMessageComponentProps, state: SubscriptionFlashMessageComponentState, cssStyle: SubscriptionFlashMessageComponentCSSStyle): JSX.Element {
        return (
            <>

                <div style={cssStyle.getWrapperCSSStyle()}>
                    <div style={cssStyle.getHeaderDivCSSStyle()}>
                        <label id={this.getContext().getUserContext().getLanguage() === LanguageConst.ENGLISH ? "subscription-flash-message-header-title" : "subscription-flash-message-header-title-burmese"} style={cssStyle.getTitleCSSStyle()}>{this.getContext().getResources().getString(Strings.choose_your_subscription_plan)}</label>
                        <div style={cssStyle.getCloseIconDivCSSStyle()} onClick={this.onCancelClick}>
                            <img src={props.context.getResources().getImage("close_red.svg")} style={cssStyle.getCloseIconCSSStyle()} />
                        </div>

                    </div>
                    <div style={{ width: '100%', marginTop: '20px', height: '19px', lineHeight: '19px', textAlign: "center" }}>
                        <label style={{ width: '100%', height: '100%', lineHeight: '100%', fontSize: '14px', color: '#898989' }}>
                            {this.getContext().getResources().getString(Strings.you_should_subscribe_a_plan_before_you_flash_message)}
                        </label>
                    </div>

                    <div style={{ width: '100%', height: '19px', lineHeight: '19px', textAlign: "center" }}>
                        <label style={{ width: '100%', height: '100%', lineHeight: '100%', fontSize: '14px', color: '#898989' }}>

                            {this.getContext().getResources().getString(Strings.what_is_subscription)}
                        </label>
                    </div>
                    <div style={{ width: '100%', display: 'flex', height: '158px', margin: '20px 35px 50px 35px' }}>
                        <div onClick={(e) => this.onDailyPackSelected(this.getContext().getConfigurationSettings().getProperty("NOTE4U_DAILY_OFFER_CODE"))} onMouseEnter={this.onDailyHovered} onMouseLeave={this.onDailyHoveredExit} style={cssStyle.getSubscriptionCircleDivCSSStyle((state.onPackselected === this.getContext().getConfigurationSettings().getProperty("NOTE4U_DAILY_OFFER_CODE")) ? true : state.isDailyHovered)}>
                            <div style={cssStyle.getSubscriptionDetailsDivCSSStyle()}>
                                <label style={{ width: '100%', height: '100%', cursor: "pointer", lineHeight: '100%' }}>
                                    {this.getContext().getResources().getString(Strings.daily_flash_charge)}
                                </label>
                            </div>
                            <div style={{ width: '100%', height: '17px', cursor: "pointer", textAlign: 'center', fontSize: '14px', lineHeight: '17px' }}>
                                {this.getContext().getResources().getString(Strings.daily_flash)}
                            </div>
                        </div>
                        <div onClick={(e) => this.onWeeklyPackSelected(this.getContext().getConfigurationSettings().getProperty("NOTE4U_WEEKLY_OFFER_CODE"))} onMouseEnter={this.onWeeklyHovered} onMouseLeave={this.onWeeklyHoveredExit} style={cssStyle.getSubscriptionCircleDivCSSStyle((state.onPackselected === this.getContext().getConfigurationSettings().getProperty("NOTE4U_WEEKLY_OFFER_CODE")) ? true : state.isWeeklyHovered)}>
                            <div style={cssStyle.getSubscriptionDetailsDivCSSStyle()}>
                                <label style={{ width: '100%', height: '100%', lineHeight: '100%', cursor: "pointer" }}>
                                    {this.getContext().getResources().getString(Strings.weekly_flash_charge)}
                                </label>
                            </div>
                            <div style={{ width: '100%', height: '17px', textAlign: 'center', cursor: "pointer", fontSize: '14px', lineHeight: '17px' }}>
                                {this.getContext().getResources().getString(Strings.weekly_flash)}
                            </div>
                        </div>
                        <div onClick={(e) => this.onMonthlyPackSelected(this.getContext().getConfigurationSettings().getProperty("NOTE4U_MONTHLY_OFFER_CODE"))} onMouseEnter={this.onMonthlyHovered} onMouseLeave={this.onMonthlyHoveredExit} style={cssStyle.getSubscriptionCircleDivCSSStyle((state.onPackselected === this.getContext().getConfigurationSettings().getProperty("NOTE4U_MONTHLY_OFFER_CODE")) ? true : state.isMonthlyHovered)}>
                            <div style={cssStyle.getSubscriptionDetailsDivCSSStyle()}>
                                <label style={{ width: '100%', height: '100%', cursor: "pointer", lineHeight: '100%' }}>
                                    {this.getContext().getResources().getString(Strings.monthly_flash_charge)}
                                </label>
                            </div>

                            <div style={{ width: '100%', height: '17px', fontSize: '14px', cursor: "pointer", textAlign: 'center', lineHeight: '17px' }}>
                                {this.getContext().getResources().getString(Strings.monthly_flash)}
                            </div>
                        </div>


                    </div>
                    <div style={{ width: '100%', height: '40px', marginLeft: '100px', marginRight: 'auto', display: 'flex' }}>
                        <div style={{ width: '180px', height: '40px' }}>
                            <ButtonComponent onClick={this.onCancelClick} style={new SubscriptionFlashMessageComponentCancelButtonCSSStyleImpl(props.context)} context={props.context} label={props.context.getResources().getString(Strings.cancel)} />
                        </div>
                        <div style={{ width: '180px', height: '40px', marginLeft: '20px' }}>
                            <ButtonComponent onClick={this.onConfirmClick} style={new ConfirmRequestConfirmButtonCSSStyleImpl(props.context)} context={props.context} label={props.context.getResources().getString(Strings.confirm)} />
                        </div>
                    </div>
                    {/* <div style={cssStyle.getRowDivCSSStyle()}>
                                    <div style={cssStyle.getTermsConditionCSSStyle()}>
                                    <a style={cssStyle.getAnchorCSSStyle()} target="_blank" href={props.context.getConfigurationSettings().getPropertyBasedOnLanguage("TND")}>
                                            {props.context.getResources().getString(Strings.terms_condition)}

                                    </a>
                                    </div>
                    </div>   */}
                </div>



            </>
        );
    }

    getMobileView(props: SubscriptionFlashMessageComponentProps, state: SubscriptionFlashMessageComponentState, cssStyle: SubscriptionFlashMessageComponentCSSStyle): JSX.Element {
        return (
            <>

                <div style={cssStyle.getMobileWrapperCSSStyle()}>
                    <div style={cssStyle.getHeaderDivCSSStyle()}>
                        <label id={this.getContext().getUserContext().getLanguage() === LanguageConst.ENGLISH ? "subscription-flash-message-header-title" : "subscription-flash-message-header-title-burmese"} style={cssStyle.getMobileTitleCSSStyle()}>{this.getContext().getResources().getString(Strings.subscription_plan)}</label>
                        <div style={cssStyle.getCloseIconDivCSSStyle()} onClick={this.onCancelClick}>
                            <img src={props.context.getResources().getImage("close_red.svg")} style={cssStyle.getCloseIconCSSStyle()} />
                        </div>

                    </div>
                    <div style={{ width: '100%', marginTop: '20px', height: '19px', lineHeight: '19px', textAlign: "center" }}>
                        <label style={{ width: '100%', height: '100%', lineHeight: '100%', fontSize: '12px', color: '#898989' }}>
                            {this.getContext().getResources().getString(Strings.you_should_subscribe_a_plan_before_you_flash_message)}
                        </label>
                    </div>

                    <div style={{ width: '100%', height: '19px', lineHeight: '19px', textAlign: "center" }}>
                        <label style={{ width: '100%', height: '100%', lineHeight: '100%', fontSize: '14px', color: '#898989' }}>

                            {this.getContext().getResources().getString(Strings.what_is_subscription)}
                        </label>
                    </div>
                    <div style={{ width: '100%', display: 'flex', height: '158px', justifyContent: "center", margin: '20px 7px 7px 7px' }}>
                        <div onClick={(e) => this.onDailyPackSelected(this.getContext().getConfigurationSettings().getProperty("NOTE4U_DAILY_OFFER_CODE"))} onMouseEnter={this.onDailyHovered} onMouseLeave={this.onDailyHoveredExit} style={cssStyle.getMobileSubscriptionCircleDivCSSStyle((state.onPackselected === this.getContext().getConfigurationSettings().getProperty("NOTE4U_DAILY_OFFER_CODE")) ? true : state.isDailyHovered)}>
                            <div style={cssStyle.getMobileSubscriptionDetailsDivCSSStyle()}>
                                <label style={{ width: '100%', height: '100%', cursor: "pointer", lineHeight: '100%' }}>
                                    {this.getContext().getResources().getString(Strings.daily_flash_charge)}
                                </label>
                            </div>

                            <div style={{ width: '100%', height: '15px', fontSize: '12px', cursor: "pointer", textAlign: 'center', lineHeight: '15px' }}>
                                {this.getContext().getResources().getString(Strings.daily_flash)}
                            </div>
                        </div>
                        <div onClick={(e) => this.onWeeklyPackSelected(this.getContext().getConfigurationSettings().getProperty("NOTE4U_WEEKLY_OFFER_CODE"))} onMouseEnter={this.onWeeklyHovered} onMouseLeave={this.onWeeklyHoveredExit} style={cssStyle.getMobileSubscriptionCircleDivCSSStyle((state.onPackselected === this.getContext().getConfigurationSettings().getProperty("NOTE4U_WEEKLY_OFFER_CODE")) ? true : state.isWeeklyHovered)}>

                            {/* <div onClick={(e)=>this.onWeeklyPackSelected("CRBT_WEEKLY")} onMouseEnter={this.onWeeklyHovered} onMouseLeave={this.onWeeklyHoveredExit} style={cssStyle.getMobileSubscriptionCircleDivCSSStyle((state.onPackselected === "CRBT_WEEKLY") ? true : state.isWeeklyHovered)}> */}
                            <div style={cssStyle.getMobileSubscriptionDetailsDivCSSStyle()}>
                                <label style={{ width: '100%', height: '100%', lineHeight: '100%', cursor: "pointer" }}>
                                    {this.getContext().getResources().getString(Strings.weekly_flash_charge)}
                                </label>
                            </div>
                            <div style={{ width: '100%', height: '15px', textAlign: 'center', cursor: "pointer", fontSize: '12px', lineHeight: '15px' }}>
                                {this.getContext().getResources().getString(Strings.weekly_flash)}
                            </div>
                        </div>
                        <div onClick={(e) => this.onMonthlyPackSelected(this.getContext().getConfigurationSettings().getProperty("NOTE4U_MONTHLY_OFFER_CODE"))} onMouseEnter={this.onMonthlyHovered} onMouseLeave={this.onMonthlyHoveredExit} style={cssStyle.getMobileSubscriptionCircleDivCSSStyle((state.onPackselected === this.getContext().getConfigurationSettings().getProperty("NOTE4U_MONTHLY_OFFER_CODE")) ? true : state.isMonthlyHovered)}>
                            <div style={cssStyle.getMobileSubscriptionDetailsDivCSSStyle()}>
                                <label style={{ width: '100%', height: '100%', cursor: "pointer", lineHeight: '100%' }}>
                                    {this.getContext().getResources().getString(Strings.monthly_flash_charge)}
                                </label>
                            </div>
                            <div style={{ width: '100%', height: '15px', cursor: "pointer", textAlign: 'center', fontSize: '12px', lineHeight: '15px' }}>
                                {this.getContext().getResources().getString(Strings.monthly_flash)}
                            </div>
                        </div>
                    </div>
                    <div style={{ width: '100%', height: '40px', marginLeft: '0px', justifyContent: "center", marginRight: 'auto', display: 'flex' }}>
                        <div style={{ width: '110px', height: '40px' }}>
                            <ButtonComponent onClick={this.onCancelClick} style={new SubscriptionFlashMessageComponentCancelButtonCSSStyleImpl(props.context)} context={props.context} label={props.context.getResources().getString(Strings.cancel)} />
                        </div>
                        <div style={{ width: '110px', height: '40px', marginLeft: '20px' }}>
                            <ButtonComponent onClick={this.onConfirmClick} style={new ConfirmRequestConfirmButtonCSSStyleImpl(props.context)} context={props.context} label={props.context.getResources().getString(Strings.confirm)} />
                        </div>
                    </div>

                    {/* <div style={cssStyle.getRowDivCSSStyle()}>
                                    <div style={cssStyle.getTermsConditionCSSStyle()}>
                                    <a style={cssStyle.getAnchorCSSStyle()} target="_blank" href={props.context.getConfigurationSettings().getPropertyBasedOnLanguage("TND")}>
                                            {props.context.getResources().getString(Strings.terms_condition)}

                                    </a>
                                    </div>
                    </div>   */}
                </div>

            </>
        );
    }


    showLoader() {

        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(true, <LoaderComponent context={this.getUIProps().context} />);
    }

    dismissLoader() {
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(false, <></>);
    }

    onMonthlyPackSelected(packName: string): void {
        (this.getUIComponentHandler() as SubscriptionFlashMessageComponentHandler).onClick(packName);
    }
    onWeeklyPackSelected(packName: string): void {
        (this.getUIComponentHandler() as SubscriptionFlashMessageComponentHandler).onClick(packName);

    }
    onDailyPackSelected(packName: string): void {
        (this.getUIComponentHandler() as SubscriptionFlashMessageComponentHandler).onClick(packName);

    }

    onCancelClick(): void {
        (this.getUIComponentHandler() as SubscriptionFlashMessageComponentHandler).onCancelClick();
    }

    onConfirmClick(): void {
        (this.getUIComponentHandler() as SubscriptionFlashMessageComponentHandler).onConfirmClick();
    }
    private onMonthlyHovered() {
        console.log("Monthly hovered");
        (this.getUIComponentHandler() as SubscriptionFlashMessageComponentHandler).onMonthlyHovered(true, false, false);
    }

    private onWeeklyHovered() {
        console.log("weekly hovered");

        (this.getUIComponentHandler() as SubscriptionFlashMessageComponentHandler).onMonthlyHovered(false, true, false);
    }
    private onDailyHovered() {
        console.log("Daily hovered");

        (this.getUIComponentHandler() as SubscriptionFlashMessageComponentHandler).onMonthlyHovered(false, false, true);
    }
    private onMonthlyHoveredExit() {
        console.log("Monthly exit");

        (this.getUIComponentHandler() as SubscriptionFlashMessageComponentHandler).onMonthlyHoveredExit();
    }
    private onWeeklyHoveredExit() {
        console.log("weekly exit");

        (this.getUIComponentHandler() as SubscriptionFlashMessageComponentHandler).onWeeklyHoveredExit();
    }

    private onDailyHoveredExit() {
        console.log("");

        (this.getUIComponentHandler() as SubscriptionFlashMessageComponentHandler).onDailyHoveredExit();
    }





}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/popup/flashmessage/flashsubscription/flashsubscriptionview.tsx